import React from 'react'
import { FormControl, FormGroup, FormLabel, MenuItem, Select } from '@mui/material'
import GamepadInput from './GamepadInput'

const masterKeys = ['correct', 'wrong', 'through', 'reset', 'undo', 'redo']

const Bind = ({ form, change }) => {
  const changeButton = key => value => {
    change.direct(value => ({ bind: { gamepad: { [key]: { $set: value } } } }))(value)

    if (masterKeys.indexOf(key) >= 0) {
      for (const masterKey of masterKeys) {
        if (key !== masterKey && value === form.bind.gamepad[masterKey]) {
          change.direct(value => ({ bind: { gamepad: { [masterKey]: { $set: value } } } }))(null)
        }
      }
    }
  }

  return (
    <>
      <FormGroup className="form-group">
        <FormLabel>キー</FormLabel>
      </FormGroup>
      <FormGroup className="form-group bind-row" row={true}>
        <FormLabel>早押し</FormLabel>
        <FormControl variant="standard">
          <Select labelId="answer-key"
                  className="answer-key wide-select"
                  MenuProps={{ className: 'answer-key-menu' }}
                  value={form.bind.key.answer}
                  onChange={change.value(value => ({ bind: { key: { answer: { $set: value } } } }))}>
            <MenuItem value="Enter" className="enter-key">Enterキー</MenuItem>
            <MenuItem value="Space" className="space-key">Spaceキー</MenuItem>
          </Select>
        </FormControl>
      </FormGroup>
      <FormGroup className="form-group mt-10">
        <FormLabel>ゲームパッド</FormLabel>
      </FormGroup>
      <FormGroup className="form-group bind-row" row={true}>
        <FormLabel>早押し</FormLabel>
        <GamepadInput value={form.bind.gamepad.answer}
                      onChange={changeButton('answer')} />
      </FormGroup>
      <FormGroup className="form-group bind-row" row={true}>
        <FormLabel>正解</FormLabel>
        <GamepadInput value={form.bind.gamepad.correct}
                      onChange={changeButton('correct')} />
      </FormGroup>
      <FormGroup className="form-group bind-row" row={true}>
        <FormLabel>誤答</FormLabel>
        <GamepadInput value={form.bind.gamepad.wrong}
                      onChange={changeButton('wrong')} />
      </FormGroup>
      <FormGroup className="form-group bind-row" row={true}>
        <FormLabel>次の問題</FormLabel>
        <GamepadInput value={form.bind.gamepad.through}
                      onChange={changeButton('through')} />
      </FormGroup>
      <FormGroup className="form-group bind-row" row={true}>
        <FormLabel>リセット</FormLabel>
        <GamepadInput value={form.bind.gamepad.reset}
                      onChange={changeButton('reset')} />
      </FormGroup>
      <FormGroup className="form-group bind-row" row={true}>
        <FormLabel>UNDO</FormLabel>
        <GamepadInput value={form.bind.gamepad.undo}
                      onChange={changeButton('undo')} />
      </FormGroup>
      <FormGroup className="form-group bind-row" row={true}>
        <FormLabel>REDO</FormLabel>
        <GamepadInput value={form.bind.gamepad.redo}
                      onChange={changeButton('redo')} />
      </FormGroup>
    </>
  )
}

export default Bind
